<app-shared-modal-header
  [applyTitle]="'Add Stock Item'"
  [isCloseIconVisible]="true"
  (emitClose)="onModalClose()">
</app-shared-modal-header>

@if (!isRetryDataLoading) {
  <div class="stock-form-wrapper">
    <form [formGroup]="getForm" class="stock-form" (ngSubmit)="onSubmit($event)">
      <section class="block basic" formGroupName="basic">
        <h3>Basic Details</h3>
        <div class="field">
          <label class="required-field">Stores</label>
          @if (retryAddStockItem) {
            <div class="retry-store-display">
              <span class="selected-code">{{ getSelectedStoresDisplay() }}</span>
            </div>
          } @else {
          <div class="custom-select">
            <input
              #storeInput
              type="text"
              data-field="store"
              [formControl]="storeSearchControl"
              [placeholder]="selectedStoresList.length ? '' : 'Select stores...'"
              (focus)="openDropdown('store', storeInput)"
              class="search-input" />
            @if (showStoreDropdown) {
              <div
                class="select-dropdown"
                [ngClass]="getDropdownPositionClass('store')">
                <div class="dropdown-list">
                  <div class="scrollable-options">
                    @if (filteredStores.length === 0) {
                      <div class="dropdown-empty">No stores found</div>
                    }
                    @for (store of filteredStores; track store.storeId) {
                      <div [style.opacity]="isStoreDisabled(store.storeId) ? '0.55' : '1'">
                        <label
                          [matTooltip]="isStoreDisabled(store.storeId) ? 'This store has no Add Stock Item settings configured' : ''"
                          [style.cursor]="isStoreDisabled(store.storeId) ? 'not-allowed' : 'pointer'">
                          <input
                            type="checkbox"
                            [checked]="isStoreSelected(store.storeId)"
                            [disabled]="isStoreDisabled(store.storeId)"
                            (change)="toggleStoreSelection(store)" />
                          {{ store.name }}
                        </label>
                      </div>
                    }
                  </div>
                  <div class="dropdown-actions">
                    <button type="button" (click)="confirmStoreSelection()" class="dropdown-btn">OK</button>
                    <button type="button" (click)="cancelStoreSelection()" class="dropdown-btn">Cancel</button>
                  </div>
                </div>
              </div>
            }
            <div class="select-arrow"></div>
            @if (selectedStoresList.length) {
              <div class="selected-value">
                <span class="selected-code">{{ getSelectedStoresDisplay() }}</span>
              </div>
            }
          </div>
          }
        </div>
        <div class="field">
          <label class="required-field">Department</label>
          @if (isMultiStore) {
            <app-shared-button
              class="per-store-field-btn"
              [disabled]="selectedStoresList.length === 0"
              (buttonClicked)="openPerStoreModal('department')">
              {{ getPerStoreButtonLabel('department') }}
              <span class="codes-count">({{ selectedStoresList.length }})</span>
            </app-shared-button>
          } @else {
            <div class="custom-select" [ngClass]="{'disabled': departmentInput.disabled}">
              <input
                #departmentInput
                type="text"
                data-field="department"
                [formControl]="departmentSearchControl"
                [placeholder]="getFormData('basic.dep') ? '' : 'Search departments'"
                (focus)="openDropdown('department', departmentInput)"
                (keydown.enter)="onEnterKeyNavigation($event, 'basic', 'dep')"
                (keydown.tab)="onEnterKeyNavigation($event, 'basic', 'dep')"
                class="search-input" />
              @if (showDepartmentDropdown) {
                <div
                  class="select-dropdown"
                  [ngClass]="getDropdownPositionClass('department')">
                  <div class="dropdown-list">
                    <div class="scrollable-options">
                      @if (isDepartmentsLoading) {
                        <div class="dropdown-loading">
                          <div class="loading-spinner"></div>
                          <span>Loading departments...</span>
                        </div>
                      } @else {
                        @for (dept of filteredDepartments; track $index) {
                          <div
                            class="dropdown-item"
                            (click)="selectDepartment(dept)">
                            {{ dept.name }}
                          </div>
                        }
                        @if (filteredDepartments.length === 0) {
                          <div class="dropdown-empty">No departments found</div>
                        }
                      }
                    </div>
                  </div>
                </div>
              }
              <div class="select-arrow"></div>
              @if (getFormData('basic.dep')) {
                <div class="selected-value">
                  <span class="selected-code">{{ getSelectedDepartmentName() }}</span>
                </div>
              }
            </div>
          }
        </div>
        <div class="field">
          <label class="required-field">Sub-Department</label>
          @if (isMultiStore) {
            <app-shared-button
              class="per-store-field-btn"
              [disabled]="selectedStoresList.length === 0 || !hasRequiredDepartmentForCodeGen()"
              [matTooltip]="!hasRequiredDepartmentForCodeGen() ? 'Select a department for each store first' : ''"
              (buttonClicked)="openPerStoreModal('subDepartment')">
              {{ getPerStoreButtonLabel('subDepartment') }}
              <span class="codes-count">({{ selectedStoresList.length }})</span>
            </app-shared-button>
          } @else {
            <div class="custom-select" [ngClass]="{'disabled': subDepartmentInput.disabled}">
              <input
                #subDepartmentInput
                type="text"
                data-field="subDepartment"
                [formControl]="subDepartmentSearchControl"
                [placeholder]="getFormData('basic.subDep') ? '' : 'Search sub-departments'"
                (focus)="openDropdown('subDepartment', subDepartmentInput)"
                (keydown.enter)="onEnterKeyNavigation($event, 'basic', 'subDep')"
                (keydown.tab)="onEnterKeyNavigation($event, 'basic', 'subDep')"
                class="search-input" />
              @if (showSubDepartmentDropdown) {
                <div
                  class="select-dropdown"
                  [ngClass]="getDropdownPositionClass('subDepartment')">
                  <div class="dropdown-list">
                    <div class="scrollable-options">
                      @if (isSubDepartmentsLoading) {
                        <div class="dropdown-loading">
                          <div class="loading-spinner"></div>
                          <span>Loading sub-departments...</span>
                        </div>
                      } @else {
                        @for (subDept of filteredSubDepartments; track $index) {
                          <div
                            class="dropdown-item"
                            (click)="selectSubDepartment(subDept)">
                            {{ subDept.name }}
                          </div>
                        }
                        @if (filteredSubDepartments.length === 0) {
                          <div class="dropdown-empty">No sub-departments found</div>
                        }
                      }
                    </div>
                  </div>
                </div>
              }
              <div class="select-arrow"></div>
              @if (getFormData('basic.subDep')) {
                <div class="selected-value">
                  <span class="selected-code">{{ getSelectedSubDepartmentName() }}</span>
                </div>
              }
            </div>
          }
        </div>
        <div class="field code-field">
          <label class="required-field">Stock Code</label>
          <div class="checkbox-field">
            <input
              type="checkbox"
              id="manualCodeEntry"
              formControlName="manualCodeEntry"
              (change)="onManualCodeEntryToggle()" />
            <label for="manualCodeEntry">Enter stock code manually</label>
          </div>
          @if (isManualCodeEntry) {
            <div class="manual-code-row">
              <input
                formControlName="code"
                type="text"
                placeholder="Enter stock code"
                autocomplete="off" />
              <app-shared-button
                [disabled]="!canCheckStockCode()"
                [matTooltip]="selectedStoresList.length === 0 ? 'Select at least one store' : ''"
                (buttonClicked)="onCheckStockCodeAvailability()">
                @if (stockCodeCheckState === 'checking') {
                  Checking<span class="bouncing-dots"><span class="dot dot-1">.</span><span
                    class="dot dot-2">.</span><span class="dot dot-3">.</span></span>
                } @else {
                  Check Stock Code
                }
              </app-shared-button>
            </div>
            @if (stockCodeCheckState === 'available') {
              <div class="check-status available">
                <app-display-icon
                  [colour]="iconColourEnum.green"
                  [icon]="icons.checkCircle">
                </app-display-icon>
                <span>{{ getStockCodeCheckMessage() }}</span>
              </div>
            } @else if (stockCodeCheckState === 'taken') {
              <div class="check-status taken">
                <app-display-icon
                  [colour]="iconColourEnum.red"
                  [icon]="icons.alertBox">
                </app-display-icon>
                <div class="check-status-detail">
                  <span>{{ getStockCodeCheckMessage() }}</span>
                  @for (conflict of stockCodeConflicts; track conflict.storeId) {
                    <span class="check-status-conflict">{{ conflict.storeName }} — {{ conflict.existingStockDescription }}</span>
                  }
                </div>
              </div>
            } @else {
              <div class="check-status pending">
                <span>Check the code before adding the item.</span>
              </div>
            }
          } @else {
            <app-shared-button
              [matTooltip]="getButtonToolTip"
              [disabled]="!hasRequiredDepartmentForCodeGen() || !hasRequiredSubDepartmentForCodeGen() || selectedStoresList.length === 0"
              (buttonClicked)="onGenerateStockCodeClick()">
              @if (isGettingItemCode) {
                Please Continue While This Loads<span class="bouncing-dots"><span class="dot dot-1">.</span><span
                  class="dot dot-2">.</span><span class="dot dot-3">.</span></span>
              } @else if (hasGeneratedCodesForAllSelectedStores()) {
                View Generated Codes
                @if (selectedStoresList.length > 1) {
                  <span class="codes-count">({{ selectedStoresList.length }})</span>
                }
              } @else {
                @if (selectedStoresList.length > 1) {
                  Generate Stock Codes
                } @else {
                  Generate Stock Code
                }
              }
            </app-shared-button>
          }
        </div>
        <div class="field">
          <label class="required-field">Description</label>
          <input
            formControlName="desc"
            type="text"
            placeholder="Enter description"
            (keydown.enter)="onEnterKeyNavigation($event, 'basic', 'desc')" />
        </div>
        <div class="field">
          <label>Alternative Description</label>
          <input
            formControlName="alternateDescription"
            type="text"
            placeholder="Enter alternative description (optional)"
            (keydown.enter)="onEnterKeyNavigation($event, 'basic', 'alternateDescription')" />
        </div>
        <div class="field">
          <label class="required-field">Barcodes</label>
          <div class="custom-select">
            <input
              #barcodesInput
              type="text"
              data-field="barcodes"
              [formControl]="barcodesSearchControl"
              [placeholder]="selectedBarcodeKeys.length ? '' : 'Add barcodes... (First = Primary)'"
              (focus)="openDropdown('barcodes', barcodesInput)"
              class="search-input" />
            @if (showBarcodesDropdown) {
              <div
                class="select-dropdown"
                [ngClass]="getDropdownPositionClass('barcodes')">
                <div class="dropdown-list">
                  <div class="barcode-add-section">
                    <input
                      #barcodeInputField
                      type="text"
                      [value]="newBarcodeInput"
                      (input)="onBarcodeInputChange($event)"
                      (keydown.enter)="addNewBarcode(); barcodeInputField.value = ''"
                      placeholder="Type barcode and press Enter or Add"
                      maxlength="50"
                      class="barcode-input" />
                    <button type="button" (click)="addNewBarcode(); barcodeInputField.value = ''"
                            class="dropdown-btn add-btn">Add
                    </button>
                  </div>
                  <div class="scrollable-options barcodes-list">
                    @if (tempSelectedBarcodes.length === 0) {
                      <div class="dropdown-empty">No barcodes added yet</div>
                    }
                    @for (barcode of tempSelectedBarcodes; track $index; let i = $index) {
                      <div class="barcode-item">
                        <span class="barcode-text">{{ barcode }}</span>
                        @if (i === 0) {
                          <span class="barcode-badge primary-badge">Primary</span>
                        } @else {
                          <span class="barcode-badge additional-badge">Additional</span>
                        }
                        <button type="button" (click)="removeBarcode(barcode)" class="remove-btn">&times;</button>
                      </div>
                    }
                  </div>
                  <div class="dropdown-actions">
                    <button type="button" (click)="confirmBarcodeSelection()" class="dropdown-btn">OK</button>
                    <button type="button" (click)="cancelBarcodeSelection()" class="dropdown-btn">Cancel</button>
                  </div>
                </div>
              </div>
            }
            <div class="select-arrow"></div>
            @if (selectedBarcodeKeys.length) {
              <div class="selected-value">
                <span class="selected-code">{{ getSelectedBarcodesDisplay() }}</span>
              </div>
            }
          </div>
          <div class="barcode-check-row">
            <app-shared-button
              [disabled]="!canCheckBarcodes()"
              [matTooltip]="selectedBarcodeKeys.length === 0 ? 'Add at least one barcode' : ''"
              (buttonClicked)="onCheckBarcodesAvailability()">
              @if (barcodeCheckState === 'checking') {
                Checking<span class="bouncing-dots"><span class="dot dot-1">.</span><span
                  class="dot dot-2">.</span><span class="dot dot-3">.</span></span>
              } @else {
                Check Barcodes
              }
            </app-shared-button>
          </div>
          @if (barcodeCheckState === 'available') {
            <div class="check-status available">
              <app-display-icon
                [colour]="iconColourEnum.green"
                [icon]="icons.checkCircle">
              </app-display-icon>
              <span>{{ getBarcodeCheckMessage() }}</span>
            </div>
          } @else if (barcodeCheckState === 'taken') {
            <div class="check-status taken">
              <app-display-icon
                [colour]="iconColourEnum.red"
                [icon]="icons.alertBox">
              </app-display-icon>
              <div class="check-status-detail">
                <span>{{ getBarcodeCheckMessage() }}</span>
                @for (conflict of barcodeConflicts; track $index) {
                  <span class="check-status-conflict">{{ getBarcodeConflictLabel(conflict) }}</span>
                }
              </div>
            </div>
          }
        </div>
        <div class="field">
          <label>Line Colour</label>
          @if (isMultiStore) {
            <app-shared-button
              class="per-store-field-btn"
              [disabled]="selectedStoresList.length === 0"
              (buttonClicked)="openPerStoreModal('lineColour')">
              {{ getPerStoreButtonLabel('lineColour') }}
              <span class="codes-count">({{ selectedStoresList.length }})</span>
            </app-shared-button>
          } @else {
            <div class="custom-select">
              <input
                #lineColorInput
                type="text"
                data-field="lineColor"
                [formControl]="lineColorSearchControl"
                [placeholder]="getFormData('basic.lineColour') ? '' : 'Search line colours'"
                (focus)="openDropdown('lineColor', lineColorInput)"
                (keydown.enter)="onEnterKeyNavigation($event, 'basic', 'lineColour')"
                (keydown.tab)="onEnterKeyNavigation($event, 'basic', 'lineColour')"
                class="search-input" />
              @if (showLineColorDropdown) {
                <div class="select-dropdown"
                     [ngClass]="getDropdownPositionClass('lineColor')">
                  <div class="dropdown-list">
                    <div class="scrollable-options">
                      @for (color of filteredLineColors; track $index) {
                        <div
                          class="dropdown-item"
                          [style.color]="getContrastColour(color.color)"
                          [style.background]="getLineColour(color)"
                          (click)="selectLineColor(color)">
                          <span class="color-preview"></span>
                          {{ color.name }}
                        </div>
                      }
                      @if (filteredLineColors.length === 0) {
                        <div class="dropdown-empty">No line colours found</div>
                      }
                    </div>
                  </div>
                </div>
              }
              <div class="select-arrow"></div>
              @if (getFormData('basic.lineColour')) {
                <div class="selected-value">
                            <span
                              class="selected-code"
                              [style.background-color]="getSelectedLineColorHex()"
                              [style.color]="getContrastColour()">
                              {{ getSelectedLineColorName() }}
                            </span>
                </div>
              }
            </div>
          }
        </div>
        <div class="field">
          <label>On Hold Code</label>
          <div class="custom-select">
            <input
              #onHoldCodeInput
              type="text"
              data-field="onHoldCode"
              [formControl]="onHoldCodeSearchControl"
              [placeholder]="getFormData('basic.onHoldCode') ? '' : 'Select on hold codes'"
              (focus)="openDropdown('onHoldCode', onHoldCodeInput)"
              (keydown.enter)="onEnterKeyNavigation($event, 'basic', 'onHoldCode')"
              (keydown.tab)="selectBestMatchOnHoldCode($event)"
              class="search-input" />
            @if (showOnHoldCodeDropdown) {
              <div
                class="select-dropdown"
                [ngClass]="getDropdownPositionClass('onHoldCode')">
                <div class="dropdown-list">
                  <div class="scrollable-options">
                    @for (option of onHoldTypes | keyvalue; track option.key) {
                      <div>
                        @if (option.value !== 'NA') {
                          <label>
                            <input
                              type="checkbox"
                              [checked]="selectedOnHoldValues.includes(option.value)"
                              (change)="toggleOnHoldCode(option.key)" />
                            {{ option.value }}
                          </label>
                        }
                      </div>
                    }
                  </div>
                  <div class="dropdown-actions">
                    <button type="button" (click)="confirmOnHoldSelection()" class="dropdown-btn">OK</button>
                    <button type="button" (click)="cancelOnHoldSelection()" class="dropdown-btn">Cancel</button>
                  </div>
                </div>
              </div>
            }
            <div class="select-arrow"></div>
            @if (getFormData('basic.onHoldCode')) {
              <div class="selected-value">
                <span class="selected-code">{{ getSelectedOnHoldCodeDisplay() }}</span>
              </div>
            }
          </div>
        </div>
        <div class="field">
          <label>Tags</label>
          <div class="custom-select">
            <input
              #tagsInput
              type="text"
              data-field="tags"
              [formControl]="tagsSearchControl"
              [placeholder]="selectedTags.length ? '' : 'Select tags...'"
              (focus)="openDropdown('tags', tagsInput)"
              class="search-input" />
            @if (showTagsDropdown) {
              <div
                class="select-dropdown"
                [ngClass]="getDropdownPositionClass('tags')">
                <div class="dropdown-list">
                  <div class="scrollable-options">
                    @if (filteredTags.length === 0) {
                      <div class="dropdown-empty">No tags found</div>
                    }
                    @for (tag of filteredTags; track tag.name) {
                      <div>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="isTagSelected(tag.name)"
                            (change)="toggleTag(tag.name)" />
                          {{ tag.name }}
                        </label>
                      </div>
                    }
                  </div>
                  <div class="dropdown-actions">
                    <button type="button" (click)="confirmTagSelection()" class="dropdown-btn">OK</button>
                    <button type="button" (click)="cancelTagSelection()" class="dropdown-btn">Cancel</button>
                  </div>
                </div>
              </div>
            }
            <div class="select-arrow"></div>
            @if (selectedTags.length) {
              <div class="selected-value">
                <span class="selected-code">{{ getSelectedTagsDisplay() }}</span>
              </div>
            }
          </div>
        </div>
      </section>
      <section class="block pricing" formGroupName="pricing">
        <h3>
          Pricing
          <button
            type="button"
            class="apply-banding-btn"
            (click)="onApplyPriceBandingClick()"
            [matTooltip]="'Click to apply price banding rules to the current prices'"
            matTooltipPosition="above">
            Apply Price Banding
          </button>
        </h3>
        <div class="pricing-grid">
          <div class="pricing-column">
            <div class="field">
              <label class="required-field">Latest Cost (excl. VAT)</label>
              <div class="input-with-icon">
                <input
                  formControlName="latestCost"
                  type="number" min="0" step="0.01" placeholder="0.00"
                  (keydown.enter)="onEnterKeyNavigation($event, 'pricing', 'latestCost')" />
              </div>
            </div>
            <div class="field">
              <label class="required-field">VAT Rate</label>
              @if (isMultiStore) {
                <app-shared-button
                  class="per-store-field-btn"
                  [disabled]="selectedStoresList.length === 0"
                  (buttonClicked)="openPerStoreModal('vatRate')">
                  {{ getPerStoreButtonLabel('vatRate') }}
                  <span class="codes-count">({{ selectedStoresList.length }})</span>
                </app-shared-button>
              } @else {
                <div
                  class="custom-select vat-rate-selector"
                  [ngClass]="{'disabled': vatRateInput.disabled}">
                  <input
                    type="text"
                    #vatRateInput
                    data-field="vatRate"
                    [formControl]="vatRateSearchControl"
                    [placeholder]="getFormData('pricing.vatRate')? '' : 'Search VAT rates'"
                    (focus)="openDropdown('vatRate', vatRateInput)"
                    (keydown.enter)="onEnterKeyNavigation($event, 'pricing', 'vatRate')"
                    (keydown.tab)="onEnterKeyNavigation($event, 'pricing', 'vatRate')"
                    class="search-input" />
                  @if (showVatRateDropdown) {
                    <div
                      class="select-dropdown"
                      [ngClass]="getDropdownPositionClass('vatRate')">
                      <div class="dropdown-list">
                        <div class="scrollable-options">
                          @for (vatRate of filteredVatRates; track $index) {
                            <div
                              class="dropdown-item"
                              (click)="selectVatRate(vatRate)">
                              {{ vatRate.description }}
                            </div>
                          }
                          @if (filteredVatRates.length === 0) {
                            <div class="dropdown-empty">No VAT rates found</div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  <div class="select-arrow"></div>
                  @if (getFormData('pricing.vatRate')) {
                    <div class="selected-value">
                      <span class="selected-code">{{ getSelectedVatRateDescription() }}</span>
                    </div>
                  }
                </div>
              }
            </div>
            <div class="field">
              <label>Recommended GP (%)</label>
              <div class="input-with-icon">
                <input
                  formControlName="recommendedGP"
                  type="number" min="0" max="100" placeholder="0"
                  (keydown.enter)="onEnterKeyNavigation($event, 'pricing', 'recommendedGP')" />
                <span class="percentage-symbol">%</span>
              </div>
            </div>
          </div>
          <div class="pricing-column">
            <div class="field">
              <label>Nominal GP (%)</label>
              <div class="input-with-icon">
                <input
                  formControlName="nominalGP"
                  type="number" min="0" max="100" step="0.01" placeholder="0.00"
                  (keydown.enter)="onEnterKeyNavigation($event, 'pricing', 'nominalGP')" />
              </div>
            </div>
            <div class="field">
              <label class="required-field">Selling Price (incl)</label>
              <div class="input-with-icon">
                <input
                  formControlName="sellPriIncl1"
                  type="number"
                  min="0" step="0.01" placeholder="0.00"
                  (keydown.enter)="onEnterKeyNavigation($event, 'pricing', 'sellPriIncl1')" />
              </div>
            </div>
            <div class="field">
              <label class="required-field">Selling Price (excl)</label>
              <div class="input-with-icon">
                <input
                  formControlName="sellPriExcl1"
                  type="number" min="0" step="0.01" placeholder="0.00"
                  (keydown.enter)="onEnterKeyNavigation($event, 'pricing', 'sellPriExcl1')" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="columns-container">
        <section class="block ordering" formGroupName="ordering">
          <h3>Ordering</h3>
          <div class="field">
            <label>Pack Size</label>
            <input
              formControlName="packSize"
              type="number" min="1" placeholder="1"
              (keydown.enter)="onEnterKeyNavigation($event, 'ordering', 'packSize')" />
          </div>
          <div class="field-row">
            <div class="field">
              <label>Order Level</label>
              <input
                formControlName="ordLvl"
                type="number" min="0" placeholder="0"
                (keydown.enter)="onEnterKeyNavigation($event, 'ordering', 'ordLvl')" />
            </div>
            <div class="field">
              <label>Min Order Level</label>
              <input
                formControlName="minOrderLevel"
                type="number" min="0" placeholder="0"
                (keydown.enter)="onEnterKeyNavigation($event, 'ordering', 'minOrderLevel')" />
            </div>
          </div>
          <div class="field">
            <label>Max Order Level</label>
            <input
              formControlName="maxOrderLevel"
              type="number" min="0" placeholder="0"
              (keydown.enter)="onEnterKeyNavigation($event, 'ordering', 'maxOrderLevel')" />
          </div>
        </section>
        <section class="block supplier" formGroupName="supplier">
          <h3>Supplier Details</h3>
          <div class="field">
            <div class="checkbox-field">
              <input
                type="checkbox"
                id="multipleSuppliers"
                formControlName="multipleSuppliers"
                (keydown.enter)="onEnterKeyNavigation($event, 'supplier', 'multipleSuppliers')" />
              <label for="multipleSuppliers">Multiple Suppliers</label>
            </div>
          </div>
          <div class="field">
            <label class="required-field">Regular Supplier</label>
            @if (isMultiStore) {
              <app-shared-button
                class="per-store-field-btn"
                [disabled]="selectedStoresList.length === 0"
                (buttonClicked)="openPerStoreModal('supplier')">
                {{ getPerStoreButtonLabel('supplier') }}
                <span class="codes-count">({{ selectedStoresList.length }})</span>
              </app-shared-button>
            } @else {
              <div class="supplier-selector">
                <input
                  #supplierInput
                  data-field="supplier"
                  [formControl]="supplierSearchControl"
                  (focus)="openDropdown('supplier', supplierInput)"
                  (keydown.enter)="onEnterKeyNavigation($event, 'supplier', 'regularSuppCode')"
                  (keydown.tab)="onEnterKeyNavigation($event, 'supplier', 'regularSuppCode')"
                  [placeholder]="getFormData('supplier.regularSuppCode') ? '' : 'Search suppliers...'"
                  class="supplier-search-input"
                  type="text" />
                @if (showSupplierDropdown) {
                  <div
                    class="supplier-dropdown"
                    [ngClass]="getDropdownPositionClass('supplier')">
                    <div class="supplier-dropdown-list">
                      @if (filteredSuppliers?.length === 0) {
                        <div class="supplier-dropdown-empty">No matching suppliers
                        </div>
                      }
                      @for (supplier of filteredSuppliers; track $index) {
                        <div
                          class="supplier-dropdown-item"
                          (click)="selectSupplier(supplier)">
                          {{ supplier.key }} - {{ supplier.description }}
                        </div>
                      }
                    </div>
                  </div>
                }
                <div class="select-arrow"></div>
                @if (getFormData('supplier.regularSuppCode')) {
                  <div class="supplier-value">
                    <span class="supplier-code">{{ getFormData('supplier.regularSuppCode') }}</span>
                  </div>
                }
              </div>
            }
          </div>
          <div class="field">
            <label>Supplier Stock Code</label>
            <input
              formControlName="suppCode"
              type="text"
              placeholder="Enter regular supplier code"
              (keydown.enter)="onEnterKeyNavigation($event, 'supplier', 'suppCode')" />
          </div>
          @if (getFormData('supplier.multipleSuppliers')) {
            @if (isMultiStore) {
              <app-shared-button
                class="per-store-field-btn"
                [disabled]="selectedStoresList.length === 0"
                (buttonClicked)="openPerStoreModal('multiSupplier')">
                {{ getPerStoreButtonLabel('multiSupplier') }}
                <span class="codes-count">({{ selectedStoresList.length }})</span>
              </app-shared-button>
            } @else {
              <div class="field">
                <label>Additional Suppliers</label>
                <div class="custom-select">
                  <input
                    #multiSupplierInput
                    type="text"
                    data-field="multiSupplier"
                    [formControl]="multiSupplierSearchControl"
                    [placeholder]="(getFormDataArray('supplier.supplierCodes'))?.length ? '' : 'Select additional suppliers'"
                    (focus)="openDropdown('multiSupplier', multiSupplierInput)"
                    (keydown.enter)="onEnterKeyNavigation($event, 'supplier', 'supplierCodes')"
                    class="search-input" />
                  @if (showMultiSupplierDropdown) {
                    <div
                      class="select-dropdown"
                      [ngClass]="getDropdownPositionClass('multiSupplier')">
                      <div class="dropdown-list">
                        <div class="scrollable-options">
                          @for (supplier of filteredMultiSuppliers; track $index) {
                            <div>
                              <label>
                                <input
                                  type="checkbox"
                                  [checked]="isSupplierSelected(supplier.key)"
                                  (change)="toggleSupplierSelection(supplier)" />
                                {{ supplier.key }} - {{ supplier.description }}
                              </label>
                            </div>
                          }
                        </div>
                        <div class="dropdown-actions">
                          <button type="button" (click)="deselectAllSuppliers()" class="dropdown-btn deselect-button">
                            Deselect
                            All
                          </button>
                          <button type="button" (click)="confirmSupplierSelection()" class="dropdown-btn">OK</button>
                          <button type="button" (click)="cancelSupplierSelection()" class="dropdown-btn">Cancel</button>
                        </div>
                      </div>
                    </div>
                  }
                  <div class="select-arrow"></div>
                  @if (getFormDataArray('supplier.supplierCodes')?.length) {
                    <div class="selected-value">
                      <span class="selected-code">{{ getSelectedSuppliersDisplay() }}</span>
                    </div>
                  }
                </div>
              </div>
            }
          }
        </section>
      </div>
      <footer class="form-actions">
        <button
          type="submit"
          class="primary-btn"
          [disabled]="isSubmitting || !getForm.valid || (isManualCodeEntry && !isManualStockCodeVerified())"
          [matTooltip]="!getForm.valid ? getInvalidFieldsMessage() : (isManualCodeEntry && !isManualStockCodeVerified() ? 'Check the stock code before adding the item' : '')"
          matTooltipPosition="above">
          @if (isSubmitting) {
            Adding Item<span class="bouncing-dots"><span class="dot dot-1">.</span><span
              class="dot dot-2">.</span><span class="dot dot-3">.</span></span>
          } @else {
            Add Item
          }
        </button>
      </footer>
    </form>

    @if (isSubmitting) {
      <div class="submitting-overlay" role="status" aria-live="polite">
        <div class="submitting-panel">
          <app-shared-loading-g [animation]="animation"></app-shared-loading-g>
          <h3>
            Adding stock item to {{ selectedStoresList.length }} {{ selectedStoresList.length === 1 ? 'store' : 'stores' }}
            <span class="bouncing-dots">
              <span class="dot dot-1">.</span>
              <span class="dot dot-2">.</span>
              <span class="dot dot-3">.</span>
            </span>
          </h3>
          <p>Please wait while the item is saved.</p>
        </div>
      </div>
    }

    @if (activePerStoreField) {
      <div class="per-store-modal-backdrop" (click)="closePerStoreModal()">
        <div class="per-store-modal" (click)="onPerStoreModalClick($event)">
          <div class="per-store-modal-header">
            <h3>{{ perStoreModalTitle }}</h3>
            <button type="button" class="per-store-close" (click)="closePerStoreModal()">&times;</button>
          </div>
          <p class="per-store-modal-hint">
            Choose a value for each store. Selecting one auto-fills the other stores with the closest
            match (same code, then name) — leave blank where there is no match.
          </p>
          @if (activePerStoreField === 'subDepartment') {
            <div class="vat-rate-warning">
              <app-display-icon
                [colour]="iconColourEnum.primary"
                [icon]="icons.infoSlabCircleOutline">
              </app-display-icon>
              <p class="per-store-modal-hint">Select a department for each store before choosing sub-departments.</p>
            </div>
          }
          @if (activePerStoreField === 'vatRate') {
            <div class="vat-rate-warning">
              <app-display-icon
                [colour]="iconColourEnum.red"
                [icon]="icons.alertRhombusOutline">
              </app-display-icon>
              <p class="per-store-modal-hint">Only VAT rates with the same percentage can be selected together.</p>
            </div>
          }
          @if (isLoadingPerStoreData) {
            <div class="per-store-loading">
              <app-shared-loading-g [animation]="animation"></app-shared-loading-g>
              <span>Loading store options…</span>
            </div>
          } @else {
            <div class="per-store-rows">
              @for (store of selectedStoresList; track store.storeId) {
                <div class="per-store-row">
                  <div class="per-store-row-label">{{ store.name }}</div>

                  <div class="custom-select per-store-select">
                    <input
                      type="text"
                      class="search-input"
                      [value]="perStoreSearchTerm[store.storeId] || ''"
                      [placeholder]="getPerStoreSelectionDisplay(store.storeId) ? '' : 'Search…'"
                      (focus)="openPerStoreDropdown(store.storeId)"
                      (input)="onPerStoreSearch(store.storeId, $event)" />
                    @if (openPerStoreDropdownStoreId === store.storeId) {
                      <div class="select-dropdown dropdown-below">
                        <div class="dropdown-list">
                          <div class="scrollable-options">
                            @switch (activePerStoreField) {
                              @case ('supplier') {
                                @for (option of getPerStoreFilteredSuppliers(store.storeId); track option.key) {
                                  <div class="dropdown-item" (click)="selectPerStoreSupplier(store.storeId, option)">
                                    {{ option.key }} - {{ option.description }}
                                  </div>
                                }
                                @if (getPerStoreFilteredSuppliers(store.storeId).length === 0) {
                                  <div class="dropdown-empty">No matching suppliers</div>
                                }
                              }
                              @case ('lineColour') {
                                @for (option of getPerStoreFilteredLineColours(store.storeId); track option.name) {
                                  <div
                                    class="dropdown-item"
                                    [style.background]="option.color"
                                    [style.color]="getContrastColour(option.color)"
                                    (click)="selectPerStoreLineColour(store.storeId, option)">
                                    <span class="color-preview"></span>
                                    {{ option.name }}
                                  </div>
                                }
                                @if (getPerStoreFilteredLineColours(store.storeId).length === 0) {
                                  <div class="dropdown-empty">No line colours found</div>
                                }
                              }
                              @case ('vatRate') {
                                @for (option of getPerStoreFilteredVatRates(store.storeId); track option.id) {
                                  <div class="dropdown-item" (click)="selectPerStoreVatRate(store.storeId, option)">
                                    {{ option.description }}
                                  </div>
                                }
                                @if (getPerStoreFilteredVatRates(store.storeId).length === 0) {
                                  <div class="dropdown-empty">No VAT rates found</div>
                                }
                              }
                              @case ('department') {
                                @let filteredDepts = getPerStoreFilteredDepartments(store.storeId);
                                @for (option of filteredDepts; track option.department) {
                                  <div class="dropdown-item" (click)="selectPerStoreDepartment(store.storeId, option)">
                                    {{ option.name }}
                                  </div>
                                }
                                @if (filteredDepts.length === 0) {
                                  <div class="dropdown-empty">No departments found</div>
                                }
                              }
                              @case ('subDepartment') {
                                @if (!selectedDepartmentByStore[store.storeId]) {
                                  <div class="dropdown-empty">Select a department for this store first</div>
                                } @else {
                                  @let filteredSubDepts = getPerStoreFilteredSubDepartments(store.storeId);
                                  @for (option of filteredSubDepts; track option.subDepartment) {
                                    <div class="dropdown-item" (click)="selectPerStoreSubDepartment(store.storeId, option)">
                                      {{ option.name }}
                                    </div>
                                  }
                                  @if (filteredSubDepts.length === 0) {
                                    <div class="dropdown-empty">No sub-departments found</div>
                                  }
                                }
                              }
                              @case ('multiSupplier') {
                                @for (option of getPerStoreFilteredSuppliers(store.storeId); track option.key) {
                                  <div class="dropdown-item-checkbox">
                                    <label>
                                      <input
                                        type="checkbox"
                                        [checked]="isPerStoreMultiSupplierSelected(store.storeId, option.key)"
                                        (change)="togglePerStoreMultiSupplier(store.storeId, option)" />
                                      {{ option.key }} - {{ option.description }}
                                    </label>
                                  </div>
                                }
                                <div class="dropdown-actions">
                                  <button type="button" (click)="deselectAllSuppliers(store.storeId)" class="dropdown-btn deselect-button">
                                    Deselect
                                    All
                                  </button>
                                </div>
                                @if (getPerStoreFilteredSuppliers(store.storeId).length === 0) {
                                  <div class="dropdown-empty">No matching suppliers</div>
                                }
                              }
                            }
                          </div>
                        </div>
                      </div>
                    }
                    <div class="select-arrow"></div>
                    @if (getPerStoreSelectionDisplay(store.storeId)) {
                      <div class="selected-value">
                        <span
                          class="selected-code"
                          [style.background-color]="activePerStoreField === 'lineColour' ? getPerStoreLineColourHex(store.storeId) : null"
                          [style.color]="activePerStoreField === 'lineColour' ? getContrastColour(getPerStoreLineColourHex(store.storeId)) : null">
                          {{ getPerStoreSelectionDisplay(store.storeId) }}
                        </span>
                      </div>
                    } @else {
                      <div class="selected-value per-store-blank">
                        <span class="selected-code">No selection</span>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }

          <div class="per-store-modal-actions">
            <button type="button" class="primary-btn" (click)="confirmPerStoreModal()">Done</button>
          </div>
        </div>
      </div>
    }
  </div>
} @else {
  <div class="loading-indicator">
    @if (retryDataLoadFailed) {
      <div class="error-container">
        <app-display-icon
          [icon]="icons.alertBox"
          [colour]="iconColourEnum.red">
        </app-display-icon>
        <h3>Failed to Load Item Details</h3>
        <p>Unable to retrieve the failed item data from notifications.</p>
        <p class="subtitle">You can still add a new item manually by clicking the button below.</p>
        <div class="error-actions">
          <button
            type="button"
            class="secondary-btn"
            (click)="onModalClose()">
            Cancel
          </button>
          <button
            type="button"
            class="primary-btn"
            (click)="isRetryDataLoading = false; retryDataLoadFailed = false; retryAddStockItem = false">
            Add New Item Manually
          </button>
        </div>
      </div>
    } @else {
      <app-shared-loading-g [animation]="animation"></app-shared-loading-g>
      <h3>
        Loading Failed Item Details
        <span class="bouncing-dots">
          <span class="dot dot-1">.</span>
          <span class="dot dot-2">.</span>
          <span class="dot dot-3">.</span>
        </span>
      </h3>
    }
  </div>
}

